/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */

export const TITLE = {
  DELETE: "Delete",
  CANCEL: "Cancel",
  DELETE_SUB_ENTERPRISE: "Delete Account",
  DELETE_SUB_ENTERPRISE_MESSAGE: "Are you sure you want to delete the Account ",
  THIS_ACTION_CANNOT_BE_UNDONE: "? This action cannot be undone.",
};
